













































// @ts-ignore
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import TimePicker from '@/components/TimePicker.vue';

@Component({
  components: { TimePicker },
})
export default class extends Vue {
  @Prop({ required: false }) readonly rules: any[];
  @Prop({ required: false, type: Boolean, default: false })
  readonly dense: boolean;
  @Prop({ required: false }) readonly dateLabel: string;
  @Prop({ required: false }) readonly timeLabel: string;

  @Model('input', { type: String })
  readonly value: string;

  dateTextInput: string;
  dateShow: boolean = false;

  get datePicker() {
    if (this.value) {
      return moment(this.value).format('YYYY-MM-DD');
    } else {
      return null;
    }
  }
  set datePicker(d: string | undefined | null) {
    if (!d) {
      this.$emit('input', null);
      return;
    }

    let time = '00:00';

    if (this.timePicker) {
      time = this.timePicker;
    }
    this.$emit(
      'input',
      moment(d + ' ' + time, 'YYYY-MM-DD HH:mm').toISOString(),
    );
  }

  get timePicker() {
    if (this.value) {
      return moment(this.value).format('HH:mm');
    } else {
      return null;
    }
  }
  set timePicker(t: string | undefined | null) {
    if (!this.datePicker) {
      this.$emit('input', null);
    } else {
      this.$emit(
        'input',
        moment(this.datePicker + ' ' + t, 'YYYY-MM-DD HH:mm').toISOString(),
      );
    }
  }

  checkDateInput() {
    if (!this.dateTextInput) {
      this.datePicker = null;
      return;
    }
    const m = moment(this.dateTextInput, 'DD/MM/YYYY');

    if (m.isValid()) {
      this.datePicker = m.format('YYYY-MM-DD');
    } else {
      this.dateTextInput = moment(this.value).format('DD/MM/YYYY');
    }
  }

  @Watch('value', { immediate: true })
  valueChanged() {
    if (this.value) {
      this.dateTextInput = moment(this.value).format('DD/MM/YYYY');
    } else {
      this.dateTextInput = '';
    }
  }
}
